<template>
  <div class="datacollapser">
    <div
      tabindex="0"
      :aria-label="`${datas[collapseKey]}: cliquez ou appuyez sur la touche entrée pour accéder aux détails`"
      @click="collapsed=!collapsed"
      @keyup="changeCollapsed($event)"
    >
      <IneaIcone
        class="collapser me-1 align-middle"
        :name="isCollapsed ? 'bi-caret-right-fill' : 'bi-caret-down-fill'"
        :color="caretColor"
        :size="caretSize"
      ></IneaIcone>
      <span :class="`collapsekey collapsekey-${caretSize} ${collapseKeyClass}`">{{ collapseContent }}</span>
    </div>
    <div v-show="!isCollapsed" :class="`collapsesubkeys collapsesubkeys-${caretSize}`">
      <div v-for="(data,key) in subDatas" :key="key">
        <div
          v-if="typeof data != 'undefined'"
          tabindex="0"
          :aria-label="`${showKeys ? (key + ': ') : ''} ${data}`"
        >
          <span v-if="showKeys" :class="subKeysClass">{{ key }} :</span>
          <span :class="subDatasClass">{{ data }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IneaIcone from "@clir/IneaIcone/IneaIcone";

/**
 * Composant de présentation d'un objet javascript sur une seule ligne dépliable
 *
 *
 * @author <span><span class="fw-bold">Pascal Ouzeau</span><a class="ms-2" href="mailto:pascal.ouzeau@dgfip.finances.gouv.fr">pascal.ouzeau@dgfip.finances.gouv.fr</a></span>
 * @since Version 1.0
 * @version 1.2
 * @displayName DataCollapser
 */
export default {
  name: "DataCollapser",
  data() {
    return {
      collapsed: this.isInitiallyCollapsed
    };
  },
  props: {
    /**
     * Objet contenant les données à collapser
     */
    datas: {
      type: Object,
      default: () => {
        return {};
      }
    },
    /**
     * Texte du collapser s'il est statique
     */
    collapseLabel: { type: String, default: "détails" },
    /**
     * Clé de l'objet utilisée comme texte du collapser s'il est dynamique
     */
    collapseKey: { type: String, default: "" },
    /**
     * Etat initial du collapser
     */
    isInitiallyCollapsed: { type: Boolean, default: false },
    /**
     * Afficher les clés ?
     */
    showKeys: { type: Boolean, default: false },
    /**
     * taille de l'icône du collapser
     * @values xxs, xs, sm, "", md, lg, xl, xxl
     */
    caretSize: {
      type: String,
      default: "xxs",
      validator: v => {
        return (
          ["xxs", "xs", "sm", "", "md", "lg", "xl", "xxl"].indexOf(v) !== -1
        );
      }
    },
    /**
     * Couleur de l'icône
     */
    caretColor: { type: String, default: "" },
    /**
     * classes du texte du collapser
     */
    collapseKeyClass: { type: String, default: "" },
    /**
     * classes des clés
     */
    subKeysClass: { type: String, default: "" },
    /**
     * classes des valeurs
     */
    subDatasClass: { type: String, default: "" }
  },
  computed: {
    collapseContent() {
      return this.collapseKey.length
        ? this.datas[this.collapseKey]
        : this.collapseLabel;
    },
    subDatas() {
      const subDatas = { ...this.datas };
      delete subDatas[this.collapseKey];
      return subDatas;
    },
    isCollapsed() {
      return this.collapsed;
    }
  },
  watch: {
    datas() {
      this.collapsed = this.isInitiallyCollapsed;
    }
  },
  methods: {
    changeCollapsed(event) {
      if (event.keyCode === 13) this.collapsed = !this.collapsed;
    }
  },
  components: { IneaIcone }
};
</script>

<docs>
```[import](./__example__/DataCollapserExample.vue)
```
</docs>